import React from 'react'
import { EChannelType } from '@unfoldrtech/portal-mic'
import { EDOOHChannelType } from '@unfoldrtech/portal-mic/dist/src/openapi/core'

import { TAllChannelTypes } from '../../../models'
import I18NText from '../../I18NText'

export function CurrentChannelTypeText({
  channelType,
}: {
  channelType?: TAllChannelTypes
}) {
  if (channelType === EChannelType.DisplayAd) {
    return (
      <>
        <I18NText id="displayAd" />
      </>
    )
  }
  if (channelType === EChannelType.SponsoredProduct) {
    return (
      <>
        <I18NText id="sponsoredProduct" />
      </>
    )
  }

  if (channelType === EDOOHChannelType.Dooh) {
    return (
      <>
        <I18NText id="digital.out.of.home" />
      </>
    )
  }
  return <> </>
}
